import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { employeeEmailSchema } from '../../helper/helper';
import toast from 'react-hot-toast';
import employeeService from '../../../../services/EmployeeService';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3
  }
}));

export default function ChangeEmailDialog({ emailDialogOpen, setEmailDialogOpen, row }) {
  const classes = useStyles();

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(employeeEmailSchema),
    defaultValues: {
      existingEmail: row?.email,
      latestEmail: '',
      employeeId: row?.id,
      employeeKeyPayId: row?.KeyPayEmployeeId,
      employeeDisplayName: row?.DisplayName
    }
  });

  const handleEmailChange = (data) => {
    const emailPayload = {
      existingEmail: data.existingEmail,
      latestEmail: data.latestEmail,
      employeeId: row?.id,
      employeeKeyPayId: row?.KeyPayEmployeeId,
      employeeDisplayName: row?.DisplayName
    };

    if (!row?.id || !row?.KeyPayEmployeeId || !row?.DisplayName) {
      return toast.error('User must have KeyPayId, EmployeId to update.');
    }

    employeeService
      .updateEmployeeEmailByAdmin(emailPayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('what is returned', data);
        toast.success('Successfully updated email');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error is:', error);
        toast.error(error?.response?.data?.message || 'Could not update email. Please try again later');
      });
  };

  return (
    <div>
      <Dialog open={emailDialogOpen} onClose={() => setEmailDialogOpen(false)} aria-labelledby="form-dialog-title">
        <form onSubmit={handleSubmit(handleEmailChange)} style={{ padding: '1.5rem' }}>
          <DialogTitle id="form-dialog-title">Update employee email address</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Controller
              control={control}
              name="existingEmail"
              render={({ field }) => (
                <>
                  <label>Current Email</label>
                  <TextField
                    variant="outlined"
                    size="small"
                    {...field}
                    autoFocus
                    id="existingEmail"
                    name="existingEmail"
                    type="text"
                    style={{ marginBottom: '1rem' }}
                    label="Current Email"
                    required
                    disabled
                  />
                </>
              )}
            />

            <Controller
              control={control}
              name="latestEmail"
              render={({ field }) => (
                <>
                  <label>New Email</label>
                  <TextField
                    variant="outlined"
                    size="small"
                    {...field}
                    autoFocus
                    id="latestEmail"
                    name="latestEmail"
                    type="text"
                    style={{ marginBottom: '1rem' }}
                    label="New Email"
                    required
                    error={!!errors.latestEmail}
                    helperText={errors.latestEmail?.message}
                  />
                </>
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEmailDialogOpen(false)} color="secondary" variant="outlined">
              Cancel
            </Button>
            <Button type="submit" color="primary" variant="contained" disabled={Object.keys(errors).length > 0}>
              Update
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ChangeEmailDialog.propTypes = {
  emailDialogOpen: PropTypes.bool,
  setEmailDialogOpen: PropTypes.func,
  row: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.string,
    KeyPayEmployeeId: PropTypes.string,
    DisplayName: PropTypes.string
  })
};
